import OpeningApi from './_openingApi';
import httpClient from '@/apis/base/httpclient';

class OpeningInventoryEntryAPI extends OpeningApi {
  constructor() {
    super();
  }
  controllerName = 'OpeningInventoryEntrys';

  /**
   * Lấy dữ liệu số dư vật tư hàng hóa chi tiết
   * NVTUAN1 20.09.2022
   */
  getOpeningInventory(param) {
    let request = {
      url: this.getAPIUrl() + '/detail',
      data: param,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Thêm hoặc cập nhật số dư tồn kho vật tư hàng hóa
   * @param {*} context
   * @param {*} param
   * @returns
   * NVTUAN1 21.09.2022
   */
  saveOpeningInventory(param) {
    let request = {
      url: this.getAPIUrl() + '/save',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Xóa số dư tồn kho vật tư hàng hóa
   * NVTUAN1 28.09.2022
   */
  deleteOpeningInventory(param) {
    let request = {
      url: this.getAPIUrl() + '/delete',
      data: param,
    };

    return httpClient.deleteAsync(request);
  }

  /**
   * Lấy thông tin detail vthh
   * pthai - 31/07/2023
   */
   getListDetail(param) {
    let request = {
      url: this.getAPIUrl() + '/ListDetail',
      data: param,
    };

    return httpClient.getAsync(request);
  }
}

export default new OpeningInventoryEntryAPI();
